import axios from "axios";

/**
 * Empty REACT_APP_BACKEND_URL → same-origin `/api` (Docker nginx proxy, or CRA setupProxy).
 * Set to e.g. http://127.0.0.1:8020 only when calling the API host directly.
 */
const BACKEND = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "");

export const api = axios.create({
  baseURL: BACKEND ? `${BACKEND}/api` : "/api",
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

// Attach Bearer token as a fallback (some environments strip 3rd-party cookies)
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("sopflow_token");
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
